// extracted by mini-css-extract-plugin
export default {"container":"ShowWarningOnMobile_container__hVfeq"};